import { Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router';

import { EmptyState } from '@/components/common/EmptyState';
import { useAuth } from '@/features/auth/useAuth';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { paths } from '@/routes/paths';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { status } = useAuth();

  useDocumentTitle('Page not found');

  const destination = status === 'authenticated' ? paths.documents : paths.login;

  return (
    <EmptyState
      title="Page not found"
      description="The page you're looking for doesn't exist or has moved."
      action={
        <Button appearance="primary" onClick={() => void navigate(destination, { replace: true })}>
          {status === 'authenticated' ? 'Go to your documents' : 'Go to sign in'}
        </Button>
      }
    />
  );
}

export default NotFoundPage;
